import axios from "axios";

//const port = process.env.NODE_ENV === "production" ? "http://xfgf.knjs.com.cn/XFGF/WebApi2" : "https://xfgf.knjs.com.cn/XFGF/WebApi2";

const port = process.env.NODE_ENV === "production" ? "https://api.tliya.cn/API" : "https://api.tliya.cn/API";

axios.defaults.baseURL = port;
// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);